import { dataScheme } from "../../color-scheme/builtin/default";

export const colorScheme = {
    default: {
        dataScheme: dataScheme,
        palette: {
            backgroundColor: "#ffffff",
            borderColor: "#e3e5e8",
            shadowColor: "rgba(33,37,44,0.1)",
            hoverBackgroundColor: "#f1f2f5",
            sliderRailColor: "#f1f3f4",
            sliderHandleColor: "#ffffff",
            sliderTrackColor: "#0040ff",
            popupBackgroundColor: "#ffffff",
            primaryFontColor: "#21252c",
            secondaryFontColor: "#606773",
            tertiaryFontColor: "#89909d",
            axisLabelFontColor: "#89909d",
            disableFontColor: "#bcc1cb",
            axisMarkerFontColor: "#ffffff",
            axisGridColor: "#f1f2f5",
            axisDomainColor: "#d9dde4",
            dataZoomHandleStrokeColor: "#aeb5be",
            dataZoomChartColor: "#c9ced8",
            playerControllerColor: "#0040ff",
            scrollBarSliderColor: "rgba(0,0,0,0.3)",
            axisMarkerBackgroundColor: "#21252c",
            markLabelBackgroundColor: "#f1f2f5",
            markLineStrokeColor: "#606773",
            dangerColor: "#e33232",
            warningColor: "#ffc528",
            successColor: "#07a35a",
            infoColor: "#3073f2",
            discreteLegendPagerTextColor: "rgb(51, 51, 51)",
            discreteLegendPagerHandlerColor: "rgb(47, 69, 84)",
            discreteLegendPagerHandlerDisableColor: "rgb(170, 170, 170)"
        }
    }
};
//# sourceMappingURL=color-scheme.js.map
